<script lang="ts">

</script>

<div class="phone-interview-instructions">
    <div class="card-no-border">
        <h1>Your Phone Interview</h1>
        <hr />
        <div>
            Have a conversation with us
        </div>

        <div style="margin: 20px 0 20px 0;">
            A representative will contact you shortly or you can call 1-888-800-6608, select option 1 to begin your phone interview
            Mon Fri 7am-8pm CST and Sat 9am-2pm CST.
        </div>

        <div>
            The interview will take approximately 20 minutes to complete. Please have the information below accessible
        </div>

        <div>
            <ul>
                <li>Social Security number and Driver's License number</li>
                <li>Other existing or pending life insurance policies</li>
                <li>Name, address and phone number of your doctor(s) and hospital(s)</li>
                <li>Current, past and planned future treatments including medications and dosages</li>
            </ul>
        </div>

        <div style="margin-top: 20px;">
            We appreciate your business. If you have any questions, please contact Protective Life at 1-800-366-9378.
        </div>
    </div>
</div>

<style lang="scss">
  @use "../../component_scss_library/layout" as layout;

  .phone-interview-instructions {
    ul {
      list-style: disc;
    }
  }
</style>
